// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"415db0dc","365":"d2f77750","366":"cdc61f02","501":"b816280f"}[chunkId] + ".chunk.js";
};